(function () {
  'use strict';

  /* ========== SCROLL BEHAVIOUR ========== */
  var header = document.querySelector('.custom-header');
  if (header) {
    var threshold = 0;
    function getHeroHeight() {
      var sections = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].offsetHeight > 200) return sections[i].getBoundingClientRect().bottom + window.scrollY;
      }
      return window.innerHeight * 0.8;
    }
    function setThreshold() { threshold = getHeroHeight(); }
    function onScroll() {
      if (window.scrollY > threshold) header.classList.add('custom-header--scrolled');
      else header.classList.remove('custom-header--scrolled');
    }
    setThreshold();
    window.addEventListener('resize', setThreshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ========== SIDEBAR OPEN / CLOSE ========== */
  var sidebar = document.getElementById('dool-sidebar');
  var backdrop = document.getElementById('dool-sidebar-backdrop');
  var hamburger = document.querySelector('.custom-header__hamburger');
  var menuBtn = document.getElementById('dool-menu-btn');
  var closeBtn = document.querySelector('.dool-sidebar__close');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger) hamburger.addEventListener('click', openSidebar);
  if (menuBtn) menuBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (backdrop) backdrop.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSidebar(); });

})();

/* ── DOOL Font Injection ─────────────────────────────────────── */
(function () {
  if (window.__doolFontInit) return;
  window.__doolFontInit = true;
  function init() {
    if (!document.querySelector('link[href*="Barlow"]')) {
      var fl = document.createElement('link');
      fl.rel = 'stylesheet';
      fl.href = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;700;800;900&family=Barlow:wght@300;400;500&display=swap';
      document.head.appendChild(fl);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ── End DOOL Font Injection ─────────────────────────────────── */
